import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});

export type LoginInput = z.infer<typeof loginSchema>;

export const signupDemoSchema = z.object({
  firstName: z.string().min(1, 'Campo requerido'),
  lastName: z.string().min(1, 'Campo requerido'),
  email: z.string().email('Email inválido'),
  phone: z.string().min(1, 'Campo requerido'),
  password: z.string().min(1, 'Campo requerido'),
  terms: z.literal(true, { errorMap: () => ({ message: 'Debes aceptar los términos' }) }),
});

export type SignupDemoInput = z.infer<typeof signupDemoSchema>;

export const invitationAcceptSchema = z
  .object({
    firstName: z.string().min(1, 'Campo requerido'),
    lastName: z.string().min(1, 'Campo requerido'),
    email: z.string().email('Email inválido'),
    password: z.string().min(1, 'Campo requerido'),
    passwordConfirm: z.string().min(1, 'Campo requerido'),
  })
  .refine(data => data.password === data.passwordConfirm, {
    message: 'Las contraseñas deben coincidir',
    path: ['passwordConfirm'],
  });

export type InvitationAcceptInput = z.infer<typeof invitationAcceptSchema>;

export const resetPasswordSchema = z
  .object({
    password: z.string().min(1, 'Campo requerido'),
    repassword: z.string().min(1, 'Campo requerido'),
  })
  .refine(data => data.password === data.repassword, {
    message: 'Las contraseñas deben coincidir',
    path: ['repassword'],
  });
